export default __webpack_public_path__ + "static/media/lubaantunGrid7.bc6901d3.webp";